import { hasTelegramCheckoutContext } from 'shared/lib/telegramCheckoutContext';

type TelegramWindow = Window & {
  Telegram?: { WebApp?: { initData?: string; platform?: string } };
};

export const requiresExternalCheckout = (): boolean => {
  const telegramWindow = window as TelegramWindow;

  return window.self !== window.top
    || hasTelegramCheckoutContext()
    || Boolean(telegramWindow.Telegram?.WebApp?.initData)
    || Boolean(telegramWindow.Telegram?.WebApp?.platform
      && telegramWindow.Telegram.WebApp.platform !== 'unknown');
};

export const getCheckoutUrl = (value: string): string => {
  const url = new URL(value);

  if (url.protocol !== 'https:' || url.username || url.password) {
    throw new Error('Invalid checkout URL');
  }

  return url.href;
};


